module.exports = "<ng-map map-type-id=\"HYBRID\" map-type-control-options=\"{mapTypeIds: ['HYBRID', 'TERRAIN'], style: 'DEFAULT'}\" zoom=\"{{vm.getZoom()}}\" on-click=\"vm.addMarker(vm)\" center=\"{{vm.getCenter()}}\" map-initialized=\"vm.onMapLoaded()\" street-view-control=\"false\" default-style=\"true\"> <marker ng-repeat=\"p in vm.positions\" position=\"{{p.pos}}\" title=\"pos: {{p.pos}}\" draggable=\"true\" on-dragend=\"vm.addMarker(vm)\"></marker> </ng-map> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/core/component/dv-map/dv-map.html
// module id = +CD4
// module chunks = 0